export default __webpack_public_path__ + "static/media/overlap.c4738664.png";